import { z } from 'zod'
import { BaseFilter } from './base'

export type ComboboxFilterValue = string | string[]

export class ComboboxFilter extends BaseFilter<ComboboxFilterValue> {
  static readonly schema = z.union([
    z.string(), // single value (option id)
    z.array(z.string()), // multiple values (array of option ids)
  ])

  parse(urlValue: string): ComboboxFilterValue | null {
    if (!urlValue) {return null}
    try {
      const jsonValue = JSON.parse(urlValue)
      return this.safeParse(jsonValue)
    } catch {
      return null
    }
  }

  serialize(value: ComboboxFilterValue): string {
    return JSON.stringify(value)
  }

  getSchema() {
    return ComboboxFilter.schema
  }
}
